<template>
  <rounded-card
    :head-text="$t('login.choose_a_country_code')"
    :padding="true"
    :show-right-btn="true"
    @set-close-status="$emit('set-close-status')"
  >
    <div>
      <div class="account-input flex bg-contain bg-no-repeat mb-3">
        <div class="img-wrapper flex justify-center items-center">
          <img src="../../../assets/common/magnifier.svg" />
        </div>
        <input
          class="flex-1 h-12 outline-none"
          type="text"
          v-model="searchData"
          :placeholder="$t('login.enter_country_code')"
          @input="debounceInput"
        />
      </div>
    </div>
    <scroller ref="countryCodeScroll" class="scroller" :height="'60%'">
      <div
        v-for="(item, index) in countryCodes"
        :key="item.code"
        class="flex justify-center mb-8 text-sm"
        :class="{ active: index === activeIndex }"
        @click="activeIndex = index"
      >
        <div class="country relative">
          <img
            v-if="index === activeIndex"
            class="circle absolute"
            src="../../../assets/common/group-471.svg"
          />
          <div class="w-24 truncate">
            {{ item.name }}
          </div>
        </div>
        <div class="code w-20 pl-8">{{ item.value }}</div>
      </div>
    </scroller>
    <div class="fixed bottom-0 left-0 w-full">
      <div class="mask h-5"></div>
      <div class="bottom-bar flex justify-center pt-2 bg-white">
        <c-button @click="setCountryCode">{{ $t('login.continue') }}</c-button>
      </div>
    </div>
  </rounded-card>
</template>

<script>
import debounce from 'lodash/debounce';
import capitalize from 'lodash/capitalize';
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';
import countryCodes from '@/lib/CountryCodes';

export default {
  components: {
    RoundedCard,
    CButton,
  },
  props: {
    countryCode: Object,
    showCountryCode: Boolean,
  },
  data() {
    return {
      activeIndex: 0,
      searchData: '',
      position: 0,
      countryCodes,
    };
  },
  mounted() {
    // scroll to target country code
    this.activeIndex = this.countryCodes.findIndex(item => item.name === this.countryCode.name);
    const scrollerHeight = document.querySelector('._v-container > ._v-content').clientHeight;
    this.position = (scrollerHeight / this.countryCodes.length).toFixed();
    this.scrollTo(this.activeIndex);
    this.debounceInput = debounce(() => {
      if (this.searchData === '') return;
      const index = this.countryCodes.findIndex(
        item =>
          item.name.startsWith(capitalize(this.searchData)) ||
          item.value.indexOf(this.searchData) > -1
      );
      if (index === this.activeIndex) return;
      this.scrollTo(index);
      this.activeIndex = index;
    }, 500);
  },
  methods: {
    scrollTo(index) {
      setTimeout(() => {
        this.$refs.countryCodeScroll.scrollTo(0, this.position * index, true);
      }, 100);
    },
    debounceInput() {},
    setCountryCode() {
      const code = this.countryCodes[this.activeIndex];
      if (code) {
        this.$emit('update:country-code', code);
      }
      this.$emit('set-close-status');
    },
  },
};
</script>

<style lang="scss" scoped>
.account-input {
  width: 309px;
  height: 45px;
  background-image: url('../../../assets/common/rectangle-1334.svg');

  input {
    background: none;
  }
}

.img-wrapper {
  min-width: 4rem;
}

.scroller {
  ::v-deep &._v-container {
    position: static;
    ._v-content {
      padding-bottom: 5rem;
    }
  }
}

.active {
  .country,
  .code {
    background: var(--brand-gradient-vertical);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.circle {
  top: 3px;
  left: -24px;
}

.mask {
  background-color: rgba(255, 255, 255, 0.6);
}

// This bar is position:fixed against the viewport, so it escapes both the
// RoundedCard and the .safe-area padding on common/Page.vue — no container fix
// can reach it. Its old pb-6 left only 24px under the button, less than the
// 34px home indicator, so the system bar sat on top of it.
// --safe-bottom comes from assets/css/common.css.
.bottom-bar {
  padding-bottom: calc(1.5rem + var(--safe-bottom));
}
</style>
